<template>
  <el-dialog :visible.sync="show" title="" @close="onDialogClose('theForm')" :close-on-click-modal="false" :append-to-body="true">
   <!--  <el-form size="small" :model="model" label-position="left" label-width="100px" ref="theForm">
      <el-form-item prop="contractStatus" :label="$t('m.current_contract_status')+':'">
        <template>
          <span v-if="model.contractStatus ===0">{{$t('m.subscription_closed')}}</span>
          <span v-if="model.contractStatus ===1">{{$t('m.sign_ing')}}</span>
        </template>
      </el-form-item>
    </el-form> -->
    <div class="p">
      {{ $t('m.current_contract_status') }} :
      <span v-if="model.contractStatus ===0">{{$t('m.subscription_closed')}}</span>
      <span v-if="model.contractStatus ===1">{{$t('m.sign_ing')}}</span>
    </div>
    <div class="overline">
      <el-table :data="tableData" v-loading="loading.table" border>
        <el-table-column :label="$t('m.sign_time')" prop="signDt"></el-table-column>
        <el-table-column :label="$t('m.release_time')" prop="cancelDt"></el-table-column>
        <el-table-column :label="$t('m.sign_status')" prop="contractStatus">
          <template slot-scope="scope">
            <span v-if="scope.row.contractStatus ===0">{{$t('m.subscription_closed')}}</span>
            <span v-if="scope.row.contractStatus ===1">{{$t('m.sign_ing')}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('m.termination_reason')" prop="undoReason" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('m.apply_time')" prop="applyTime"></el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>

import { getAnchorContractLog } from '../../../api/approval/anchor-approval';

export default {
  name: 'sign-contract-dialog',
  data() {
    return {
      loading: {
        table: true,
        btn: false
      },
      tableData: [],
      show: false,
      model: {
        contractStatus: null,
        userId: null,
        guildId: null,
      },
      pager: {
        page: 1,
        limit: 10,
        total: 0
      },
    };
  },

  methods: {
    showDialog(row) {
      console.log(row);
      this.model.userId = row.userId;
      this.model.guildId = row.guildId;
      this.model.contractStatus = row.contractStatus;
      this.getTableData();
      this.show = true;
    },
    getTableData() {
      this.loading.table = true;
      getAnchorContractLog({
          query: this.model,
          pager: this.pager,
          sorter: this.sorter
      })
        .then(({ data }) => {
          this.tableData = data.data.list;
          this.loading.table = false;
        })
        .catch(error => {
          this.loading.table = false;
        });
    },

    onDialogClose(formRef) {
      this.tableData = []
      this.$emit('done');
      // this.$refs[formRef].resetFields();
    }
  }
};
</script>
<style scoped>
.p{
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/approval/dialogs/signContractDialog.vue